import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { errMsg } from '@/services/staffAttendanceApi';
import { ewbInwardApi } from '@/services/ewayBillApi';
import { PartyFields } from '@/components/ewayBill/ManualDcForm';

const KEYS = ['legal_name', 'gstin', 'address1', 'address2', 'place', 'pincode', 'state'];
const pick = (s) => Object.fromEntries(KEYS.map((k) => [k, s?.[k] || '']));
const billsNote = (r) => (r.bills_updated || r.bills_kept
  ? ` — ${r.bills_updated} saved bill(s) updated${r.bills_kept ? `, ${r.bills_kept} with an e-way bill kept as sent` : ''}` : '');

/** Add a supplier by hand, or fix a saved one (its saved inward bills without an e-way bill follow). `supplier` {} = new. */
export const SupplierDialog = ({ supplier, states, onClose, onSaved }) => {
  const [p, setP] = useState(pick(null));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (supplier) setP(pick(supplier)); }, [supplier]);
  const isNew = !supplier?.id;
  const save = () => {
    setBusy(true);
    (isNew ? ewbInwardApi.addSupplier(p) : ewbInwardApi.saveSupplier(supplier.id, p))
      .then((r) => { toast.success(`${r.legal_name} saved${billsNote(r)}`); onSaved(); })
      .catch((e) => toast.error(errMsg(e, 'Save failed'), { duration: 8000 })).finally(() => setBusy(false));
  };
  return (
    <Dialog open={!!supplier} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl" data-testid="supplier-dialog">
        <DialogHeader><DialogTitle>{isNew ? 'Add supplier' : 'Edit supplier'}</DialogTitle></DialogHeader>
        {!isNew && <p className="text-xs text-gray-600">Saved inward bills of this supplier that don't have an e-way bill yet get the new details too.</p>}
        <PartyFields party={p} onChange={(k, v) => setP({ ...p, [k]: v })} states={states} labels={{ legal_name: 'Supplier name' }} prefix="supplier" />
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} data-testid="supplier-cancel-btn">Cancel</Button>
          <Button onClick={save} disabled={busy || !p.legal_name.trim() || !p.gstin} className="bg-[#2D5F4F] hover:bg-[#234A3D]" data-testid="supplier-save-btn">
            {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Save supplier</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SupplierDialog;
